// A wrapper to render to the tour filters on mobile
// Controls filter behavior and state management between the parent TourFilters component
import React, { Component } from 'react';

import DateFilter from '../date/DateFilter';
import GuestFilter from '../guest/GuestFilter';
import CategoryFilter from '../category/CategoryFilter';
import LocationFilter from '../location/LocationFilter';

import './MobileFilters.scss';

class MobileFilters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      popoverOpen: false,
      selectedFilters: [],
    };
  }

  filterRefs = () => {
    return [
      this.dateFilter,
      this.guestFilter,
      this.categoryFilter,
      this.countryFilter,
      this.cityFilter,
    ];
  };

  closePopover = () => {
    this.setState({ popoverOpen: false });
    const filters = this.filterRefs();
    filters.forEach((filter) => {
      filter.instanceRef.clearFilter();
    });
  };

  openPopover = () => {
    const filters = this.filterRefs();
    filters.forEach((filter) => {
      filter.instanceRef.updateSelectedWithApplied();
    });

    this.setState({ popoverOpen: true });
  };

  updateMobileFilters = (name, data) => {
    this.setState((prevState) => {
      const selectedFilters = prevState.selectedFilters.slice();

      const appliedFilterIndex = selectedFilters.findIndex(
        (filter) => filter.name === name
      );
      if (appliedFilterIndex === -1) {
        selectedFilters.push({ name, data });
      } else {
        selectedFilters[appliedFilterIndex] = { name, data };
      }

      return { selectedFilters };
    });
  };

  applyFilters = () => {
    this.props.applyMultipleFilters(this.state.selectedFilters);
    this.closePopover();
  };

  clearAllFilters = () => {
    const filters = [
      this.dateFilter,
      this.guestFilter,
      this.categoryFilter,
      this.cityFilter,
    ];
    filters.forEach((filter) => {
      filter.instanceRef.clearFilter();
    });

    this.setState({ selectedFilters: [] });
    this.props.clearAllAppliedFilters();
    this.closePopover();
  };

  renderHeader = () => {
    return (
      <div className="header">
        <div className="action brand-color" onClick={this.closePopover}>
          Cancel
        </div>
        <div className="heading">Filters</div>
        <div className="action apply brand-color" onClick={this.applyFilters}>
          Apply
        </div>
      </div>
    );
  };

  render() {
    const {
      commonFilterProps,
      dateFilterProps,
      guestFilterProps,
      categoryFilterProps,
      countryFilterProps,
      cityFilterProps,
    } = this.props;

    const filterApplied = this.props.anyFiltersApplied();
    const checkMark = <i className="icon af-checkmark" />;

    const mobileFilterProps = {
      mobile: true,
      updateMobileFilters: this.updateMobileFilters,
    };

    return (
      <div className="filter mobile">
        <div
          className={`
          filterButton brand-border
          ${filterApplied ? 'filterApplied brand-bg' : null}
          `}
          onClick={this.openPopover}
        >
          <div className="buttonText">Filters</div>{' '}
          {filterApplied ? checkMark : null}
        </div>

        <div
          className={`mobileFiltersPopover ${
            this.state.popoverOpen ? 'open' : 'closed'
          }`}
        >
          {this.renderHeader()}
          <div className="popoverBody">
            <DateFilter
              ref={(f) => {
                this.dateFilter = f;
              }}
              {...commonFilterProps}
              {...dateFilterProps}
              {...mobileFilterProps}
              disableOnClickOutside
            />
            <GuestFilter
              ref={(f) => {
                this.guestFilter = f;
              }}
              {...commonFilterProps}
              {...guestFilterProps}
              {...mobileFilterProps}
            />
            <CategoryFilter
              ref={(f) => {
                this.categoryFilter = f;
              }}
              {...commonFilterProps}
              {...categoryFilterProps}
              {...mobileFilterProps}
            />
            <LocationFilter
              ref={(f) => {
                this.countryFilter = f;
              }}
              {...commonFilterProps}
              {...countryFilterProps}
              {...mobileFilterProps}
            />
            <LocationFilter
              ref={(f) => {
                this.cityFilter = f;
              }}
              {...commonFilterProps}
              {...cityFilterProps}
              {...mobileFilterProps}
            />

            <div className="footer-actions">
              <div
                className="action clear filterBody mobile brand-color"
                onClick={this.clearAllFilters}
              >
                Clear All
              </div>
              <div
                className="action apply filterBody mobile brand-color"
                onClick={this.applyFilters}
              >
                Apply
              </div>
              <div className="action empty filterBody mobile" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MobileFilters;
